module.exports = __webpack_public_path__ + "img/banner01.298374f6.jpg";